// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1054":"5f74ef15","2105":"8fc763e1","6570":"a1cc6be9","7707":"5f74ef15"}[chunkId] + ".chunk.css";
};